import * as yup from 'yup';

const toNumber = (val, orig) => {
  if (orig === '' || orig == null) return undefined;         // '' | null | undefined -> undefined
  if (typeof orig === 'string' && orig.trim() !== '' && !isNaN(Number(orig))) {
    return Number(orig);                                      // "0"/"1" -> 0/1
  }
  return val;
};

const numberRequired = (label) =>
  yup
    .number()
    .transform(toNumber)
    .typeError(`Bitte ${label} auswählen.`)
    .required(`Bitte ${label} auswählen.`);

const positivePrice = (label) =>
  yup
    .number()
    .transform((val, orig) => (orig === '' || orig == null ? undefined : val))
    .typeError(`Der ${label} muss eine Zahl sein`)
    .required(`Der ${label} ist erforderlich`)
    .moreThan(0, `Der ${label} muss größer als 0 sein`);

const conditionalNumber = (deps, predicate, label) =>
  yup.mixed().when(deps, {
    is: (...args) => predicate(...args),
    then: () => positivePrice(label),
    otherwise: (s) => s.strip(), // Feld komplett ignorieren, wenn Bedingung nicht zutrifft
  });

export const priceListSchema = yup.object({
  variety: yup
    .string()
    .typeError('Bitte Sorte auswählen.')
    .required('Bitte Sorte auswählen.'),
  quality: yup
    .string()
    .when('delivery_type', {
      is: (val) => Number(val) !== 1,
      then: (s) =>
        s.typeError('Bitte Qualität auswählen.').required('Bitte Qualität auswählen.'),
      otherwise: (s) => s.notRequired(),
    }),
  contract_type: numberRequired('Vertragsart'),
  delivery_type: numberRequired('Lieferart'),
  price_list_type: numberRequired('Preisliste'),
  prices: yup.array().when('contract_type', {
    is: (ct) => Number(ct) === 0,
    then: (s) =>
      s
        .of(positivePrice('Preis'))
        .min(1, 'Mindestens ein Preis ist erforderlich')
        .required('Preisliste ist erforderlich'),
    otherwise: (s) => s.strip(),
  }),
  price_kg: conditionalNumber(
    ['contract_type', 'delivery_type'],
    (ct, dt) => Number(ct) !== 0 && Number(dt) === 0,
    'Preis / kg'
  ),
  price_kg_alpha: conditionalNumber(
    ['contract_type', 'delivery_type'],
    (ct, dt) => Number(ct) !== 0 && Number(dt) !== 0,
    'Preis / kg (alpha)'
  ),
});
